"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var EventHandlerService = /** @class */ (function () {
    function EventHandlerService(callback) {
        if (callback === void 0) { callback = function (eventHandler) { }; }
        this.events = [];
        this.callback = callback;
    }
    EventHandlerService.prototype.AddEvent = function (event) {
        this.events.push(event);
        this.callback(this);
    };
    EventHandlerService.prototype.HasEvent = function () {
        return this.events.length > 0;
    };
    EventHandlerService.prototype.GetEvent = function () {
        return this.events.length > 0 ? this.events[0] : null;
    };
    EventHandlerService.prototype.UpdateEvent = function () {
        this.callback(this);
    };
    EventHandlerService.prototype.HandleEvent = function () {
        this.events.reverse().pop();
        this.callback(this);
    };
    return EventHandlerService;
}());
exports.EventHandlerService = EventHandlerService;
exports.EventHandler = new EventHandlerService();
var EventHandlerServiceProvider = /** @class */ (function () {
    function EventHandlerServiceProvider() {
        this.service = new EventHandlerService();
    }
    EventHandlerServiceProvider.prototype.GetInstance = function () {
        return this.service;
    };
    EventHandlerServiceProvider.prototype.Set = function (callback) {
        this.service = new EventHandlerService(callback);
    };
    return EventHandlerServiceProvider;
}());
;
exports.EventHandlerProvider = new EventHandlerServiceProvider();
//# sourceMappingURL=EventHandlerService.js.map